import { React, useState, useParams, useEffect } from '../utils/thirdpartyComponents';
import * as Yup from 'yup';
import { Button } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import CWInput from "src/components/CWInput";
import CWInputGroup from "src/components/CWInputGroup";
import "src/styles/inner-page-styles.scss";
import { buildSignupSchema } from 'src/validations/signupSchema';
import { getActiveCountryCode } from 'src/utils/countryHelper';
import { EMAIL_MAX_LENGTH, PROFILE_NAME_MAX_LENGTH, REFERRAL_LENGTH, PHONE_MAX_LENGTH } from 'src/utils/constants';
import { pageURLs } from 'src/utils/pageUrls';
import { formatPhoneNumber } from "../utils/helper";
import { ISignupData } from '../interfaces/generalInterface';
import { resetAuthState } from 'src/store/slices/authSlice';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { getCompanySettings } from 'src/store/actions/settingsAction';
import SmallLoader from "src/components/SmallLoader";
const LazyCheckbox = React.lazy(() => import("src/components/CWChecBoxLabel"));
import { Suspense, useTransition } from 'react';
import { RootState } from 'src/store';
import { SignupApi } from 'src/utils/apiUrls';
import { MessageToaster } from 'src/utils/toastUtil';
import axios from '../config/axiosConfig';
import RadioButton from 'src/components/RadioButton';

const SignUpWithCar = () => {
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  
  
      // Instantiate MessageToaster
      const toaster = new MessageToaster();

  const [formData, setFormData] = useState<ISignupData>({
    carWashId: 0,
    name: '',
    phone: '',
    email: '',
    appliedReferralCode: '',
    receivesms: false,
  });

  const [errors, setErrors] = useState({
    name: '',
    phone: '',
    email: '',
    referralCode: '',
    receivesms: '',
  });
   const { getSettings, getSettingsErrorCode } = useAppSelector(
          (state: RootState) => state.settings,);

  const [showCouponRemoveBtn, setCouponRemoveBtn] = useState(false);
  const [couponCodeFldDisable, setCouponCodeFldDisable] = useState(true);
  const [redeemBtnDisabled, setRedeemBtnDisabled] = useState(true);
  const [discountCodeLabel,setdiscountCodeLabel] = useState('Promo Code');
  const [appliedCoupon,setAppliedCoupon] = useState(false)
  
  
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    const saved = localStorage.getItem("signup_data");
    if (saved) 
      {
         const parsed = JSON.parse(saved);
        setFormData(parsed);
        if (parsed.appliedCoupon) setAppliedCoupon(parsed.appliedCoupon);
        // setFormData(JSON.parse(saved));
      }
    localStorage.removeItem('CARWASH_COMPANY_DATA');
    if (!localStorage.getItem('carWashId')) {
      fetchAppSettings({ carwashname: params.carwashname });
    }
    dispatch(resetAuthState());
  }, []);



  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === "phone") {
      const onlyDigits = value.replace(/\D/g, '');
      const formatted = formatPhoneNumber(onlyDigits);
      setFormData({ ...formData, phone: formatted });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
   // Enable tick icon for referral code when string length is greater or equal to 5
    
    if (name === "appliedReferralCode") {
      setRedeemBtnDisabled(value === "");
    }
  };

  const handleCheckboxChange = (checked: boolean, name: string) => {
    setErrors({ ...errors, [name]: "" });
    setFormData({ ...formData, [name]: checked });
  };

  const fetchAppSettings = async (request: any) => {
    await dispatch(getCompanySettings(request));
  };

  const handleNext = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      if(formData.appliedReferralCode!="" && appliedCoupon==false)
            {
               toaster.toastError("To use your discount code, click Apply before signing up.");  
               return false
            }
      await buildSignupSchema(getActiveCountryCode()).validate(formData, { abortEarly: false });

      // localStorage.setItem("signup_data", JSON.stringify(formData));
      const saved = JSON.parse(localStorage.getItem("signup_data") || "{}");
      localStorage.setItem("signup_data", JSON.stringify({ ...saved, ...formData,appliedCoupon:appliedCoupon }));
      navigate(`/${params.carwashname}/signup-carinfo`, { state: { ...saved, ...formData } });
      // navigate(`/${params.carwashname}/signup-carinfo`, { state: formData });

    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const newErrors: any = {};
        error.inner.forEach((err) => {
          newErrors[err.path as keyof typeof formData] = err.message;
        });
        setErrors(newErrors);
      }
    }
  };
    const referralCoupnCheck = async () => {
        if(formData.appliedReferralCode == "") {
            toaster.toastError("Please enter valid referral code.");
            return false;
        }
        const requestPayload ={
            referralCode : formData.appliedReferralCode,
            CarWashURL : params.carwashname,
            referralType :formData.referralType

        }
        setLoading(true);
        await axios.post(SignupApi.VALIDATE_REFERRAL_CODE, requestPayload)
            .then(function (response : any){
                setLoading(false);
                setAppliedCoupon(true)

                if(response.data.error === 0) {
                    if(response.data.data.validCoupon === true) {
                        toaster.toastSuccess(response.data.message);
                        setCouponRemoveBtn(true)
                        setCouponCodeFldDisable(true)
                    } else{
                        toaster.toastError(response.data.message);
                        setCouponRemoveBtn(false)
                        setCouponCodeFldDisable(false);
                        setFormData({
                            ...formData,
                            ['appliedReferralCode']: '', 
                        });
                    }
                } else {
                    toaster.toastError(response.data.message);
                    setCouponRemoveBtn(false)
                    setCouponCodeFldDisable(false);
                    setFormData({
                        ...formData,
                        ['appliedReferralCode']: '', 
                    });
                }
            })

    };
  const referralCouponRemove = () => {
    setRedeemBtnDisabled(false);
    setCouponRemoveBtn(false);
    setCouponCodeFldDisable(false);
    setAppliedCoupon(false);
    setFormData({ ...formData, appliedReferralCode: '' });
  };

        // Function to handle coupon code type selection
        const handlePromoCodeTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            // setError(null)
            setCouponCodeFldDisable(false)
            setFormData({
                ...formData,
                ['referralType']: Number(event.target.value),
                // ['custpromocode']: '',
            });
            if(event.target.value == '1') {
                setdiscountCodeLabel('Referal Code')
            } else {
                setdiscountCodeLabel('Family Code')
            }
        };
  return (
    <div className="common-content-wrap pb-0">
      <div className="common-header">
        <div className="pe-4 ps-4 pt-0 pb-0 h-100">
          <div className="common-header-inner">Sign Up</div>
        </div>
      </div>

      <div className="inner-content-wrap signup-block">
        <div className="main-content-wrap">
          <form onSubmit={handleNext}>
            <CWInput id="name" name="name" value={formData.name} placeholder="Name" label="Name" isMandatory autoFocus maxLength={PROFILE_NAME_MAX_LENGTH} errorMessage={errors.name} onChange={handleInputChange} />
            <CWInput id="phone" name="phone" value={formData.phone} placeholder="Phone Number" label="Phone Number" labelSuffix=" (Used for Sign In)" isMandatory maxLength={PHONE_MAX_LENGTH} errorMessage={errors.phone} onChange={handleInputChange} inputmode="numeric"/>
            <CWInput id="email" name="email" value={formData.email} placeholder="Email Address" label="Email Address" isMandatory maxLength={EMAIL_MAX_LENGTH} errorMessage={errors.email} onChange={handleInputChange} />

             <div className="promo-radio mb-2">
                        <div className="form-group">
                        <label>Have a Discount Code?</label>
                        </div>
                            <div className="location-info-card d-flex">
                                <RadioButton 
                                    name="promoCodeType"
                                    label="Referal Code"
                                    checked = {formData.referralType == 1 ? true : false}
                                    value={1} 
                                    onChange={handlePromoCodeTypeChange} 
                                    // disabled={disabledCodeSelection}
                                /> 
                                <RadioButton 
                                    name="promoCodeType"
                                    label="Family Code" 
                                    checked = {formData.referralType == 2 ? true : false}
                                    value={2} 
                                    onChange={handlePromoCodeTypeChange} 
                                    // disabled={disabledCodeSelection}
                                />
                               
                            </div>
                        </div>
                        {/* <div className="promo-input position-relative">
                            <CWInputGroup
                                id="custpromocode"
                                name="custpromocode"
                                placeholder={discountCodeLabel}
                                type="text"
                                inputmode="numeric" // This helps mobile devices to show a numeric keypad
                                //label={"Have a "+discountCodeLabel+"?"}
                                value={formData.custpromocode}
                                errorMessage={errors.custpromocode && errors.custpromocode}
                                autoFocus={true}
                                maxLength={PROMO_LENGTH}
                                inputIcons={enableIcon ? TickIcon : ""}
                                onChange={handleInputChange}
                                showLabel = {false}
                            />
                        </div> */}

                    <div className="promo-input position-relative">
                        <CWInputGroup
                            id="appliedReferralCode"
                            name="appliedReferralCode"
                            placeholder={discountCodeLabel}
                            type="number"
                            label={discountCodeLabel}
                            errorMessage={errors.referralCode && errors.referralCode}
                            //inputIcons={enableIcon ? TickIcon : ""}
                            onChange={handleInputChange}
                            disabled={couponCodeFldDisable}
                            value={formData.appliedReferralCode}
                        />

                        {(!showCouponRemoveBtn ) &&<Button variant="primary"  className="primary-btn promo-btn" disabled={redeemBtnDisabled} onClick={() => referralCoupnCheck()}>Apply</Button>}
                        {(showCouponRemoveBtn ) && <Button variant="secondary" className="promo-btn"  onClick={referralCouponRemove}>Remove</Button> }
                        </div>
            <Suspense fallback={<div>Loading checkbox...</div>}>
              {!isPending && (
                <LazyCheckbox
                  id="receivesms"
                  name="receivesms"
                  label={<>I agree to receive recurring automated text messages at the phone number provided. Messages & data rates may apply. Message frequency varies. Reply HELP for help and STOP to cancel. <Link to="https://www.carwashapp.com/privacy-policy.html" target="_blank">Privacy Policy</Link> and <Link to="https://www.carwashapp.com/terms-of-service.html" target="_blank">Terms of Service</Link>.</>}
                  type="checkbox"
                  checked={formData.receivesms}
                  onChange={(e) => startTransition(() => handleCheckboxChange(e.target.checked, 'receivesms'))}
                  errorMessage={errors.receivesms}
                />
              )}
            </Suspense>
    
            <Button type="submit" className="primary-btn btn-main" title='Sign Up'>Next</Button> 
          </form>

          <div className="signin-link text-center pb-5">
            <p>Already have an account?</p>
            <Link to={`/${params.carwashname}${pageURLs.root}`}>Sign In</Link>
          </div>
        </div>
      </div>
      {loading && <SmallLoader />}
    </div>
  );
};

export default SignUpWithCar;
